import { QuillDocumentImage, UploadQuillDocumentImage } from "../dtos/Tmd.dtos";
import { RefObject } from "react";
import ReactQuill from "react-quill-new";
import { client } from "../dtos/Client";

const handleImageUpload = (
    quillRef: RefObject<ReactQuill | null>,
    callback: (quillDocumentImage?: QuillDocumentImage) => any,
    quillDocumentId: number
) => {
    if (!quillRef.current) return;

    const editor = quillRef.current.getEditor();
    const savedRange = editor.getSelection();

    const input = document.createElement("input");
    input.setAttribute("type", "file");
    input.setAttribute("accept", "image/*");
    input.click();

    const upload = async () => {
        if (!input.files?.length) {
            input.remove();
            input.removeEventListener("change", upload);
            return;
        }

        const file = input.files[0];
        const formData = new FormData();
        formData.append("file", file);

        try {
            const response = await client.apiForm(
                new UploadQuillDocumentImage({quillDocumentId: quillDocumentId}),
                formData,
                undefined,
                "post"
            );

            if (!quillRef.current) return;
            const editor = quillRef.current.getEditor();

            editor.focus();

            const range =
                savedRange && savedRange.index <= editor.getLength()
                ? savedRange
                : { index: editor.getLength(), length: 0 };

            editor.insertEmbed(range.index, "image", response.response?.url);

            editor.setSelection(range.index + 1);

            callback(response.response?.quillDocumentImage);
        } finally {
            input.remove();
            input.removeEventListener("change", upload);
        }
    };

    input.addEventListener("change", upload);
};

export default handleImageUpload;

